import React from "react";
import { SVGProps } from "react"


export default function Contact(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_246_6670"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="40"
        height="40"
      >
        <rect width="40" height="40" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_246_6670)">
        <path
          d="M13.333 23.334H26.6663V22.4173C26.6663 21.1951 26.0552 20.209 24.833 19.459C23.6108 18.709 21.9997 18.334 19.9997 18.334C17.9997 18.334 16.3886 18.709 15.1663 19.459C13.9441 20.209 13.333 21.1951 13.333 22.4173V23.334ZM19.9997 16.6673C20.9163 16.6673 21.7011 16.3409 22.3538 15.6882C23.0066 15.0354 23.333 14.2507 23.333 13.334C23.333 12.4173 23.0066 11.6326 22.3538 10.9798C21.7011 10.327 20.9163 10.0007 19.9997 10.0007C19.083 10.0007 18.2983 10.327 17.6455 10.9798C16.9927 11.6326 16.6663 12.4173 16.6663 13.334C16.6663 14.2507 16.9927 15.0354 17.6455 15.6882C18.2983 16.3409 19.083 16.6673 19.9997 16.6673ZM3.33301 36.6673V6.66732C3.33301 5.75065 3.6594 4.96593 4.31217 4.31315C4.96495 3.66037 5.74967 3.33398 6.66634 3.33398H33.333C34.2497 3.33398 35.0344 3.66037 35.6872 4.31315C36.34 4.96593 36.6663 5.75065 36.6663 6.66732V26.6673C36.6663 27.584 36.34 28.3687 35.6872 29.0215C35.0344 29.6743 34.2497 30.0007 33.333 30.0007H9.99967L3.33301 36.6673Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
}
